
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Header from '@/components/sections/Header';
import Footer from '@/components/sections/Footer';
import OgMeta from '@/components/OgMeta';

const TermosUsoPage: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-dark-base">
      <Helmet>
        <title>Termos de Uso | Dr. Luis Brunello</title>
        <meta name="description" content="Termos de Uso do site do Dr. Luis Brunello. Conheça as regras de utilização deste site." />
        <link rel="canonical" href="https://luisbrunello.com.br/termos-de-uso" />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <OgMeta
        title="Termos de Uso | Dr. Luis Brunello"
        description="Termos de Uso do site do Dr. Luis Brunello. Conheça as regras de utilização deste site."
        path="/termos-de-uso"
      />

      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} scrollToSection={() => {}} onOpenBooking={() => {}} />

      <main className="pt-28 pb-20">
        <div className="container mx-auto px-6 lg:px-12 max-w-3xl">

          {/* Breadcrumb */}
          <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-xs text-light-muted mb-10">
            <Link to="/" className="hover:text-gold transition-colors">Home</Link>
            <span aria-hidden="true">/</span>
            <span className="text-light-secondary" aria-current="page">Termos de Uso</span>
          </nav>

          <article className="space-y-8 text-light-muted text-sm leading-relaxed">
            <header>
              <p className="subtitle-wide text-gold mb-3 block">Legal</p>
              <h1 className="text-3xl md:text-4xl text-light-primary tracking-tight leading-tight mb-4">
                Termos de Uso
              </h1>
              <p className="text-light-muted text-sm mb-10">Última atualização: abril de 2025</p>
            </header>

            <section>
              <h2 className="text-lg text-light-primary font-medium mb-3">1. Aceitação dos Termos</h2>
              <p>Ao acessar e utilizar este site, você declara que leu, entendeu e concorda com estes Termos de Uso. Caso não concorde com alguma disposição, recomendamos que não utilize o site. O uso contínuo do site após alterações nos termos implica aceitação das modificações.</p>
            </section>

            <section>
              <h2 className="text-lg text-light-primary font-medium mb-3">2. Finalidade do site</h2>
              <p>Este site tem caráter exclusivamente informativo e destina-se à divulgação dos serviços de cirurgia plástica prestados pelo Dr. Luis Brunello (CRM-PR 40.350). O conteúdo disponibilizado — textos, imagens, vídeos e demais materiais — não substitui, em hipótese alguma, consulta médica presencial, diagnóstico ou tratamento profissional.</p>
            </section>

            <section>
              <h2 className="text-lg text-light-primary font-medium mb-3">3. Propriedade intelectual</h2>
              <p>Todo o conteúdo deste site, incluindo textos, logotipos, fotografias, vídeos, layout e código-fonte, é de propriedade exclusiva do Dr. Luis Brunello ou de seus licenciantes, sendo protegido pelas leis de direitos autorais e propriedade intelectual vigentes no Brasil. É vedada a reprodução, distribuição, modificação ou uso comercial sem autorização prévia por escrito.</p>
            </section>

            <section>
              <h2 className="text-lg text-light-primary font-medium mb-3">4. Uso permitido</h2>
              <p className="mb-2">Você pode utilizar este site para:</p>
              <ul className="list-disc list-inside space-y-1 pl-2">
                <li>Obter informações sobre os procedimentos e serviços oferecidos;</li>
                <li>Entrar em contato para agendamento de consultas;</li>
                <li>Compartilhar conteúdos por meio dos recursos disponíveis no site.</li>
              </ul>
              <p className="mt-2">É expressamente proibido utilizar o site para fins ilegais, para disseminar conteúdo ofensivo ou para tentar comprometer a segurança da plataforma.</p>
            </section>

            <section>
              <h2 className="text-lg text-light-primary font-medium mb-3">5. Limitação de responsabilidade</h2>
              <p>As informações contidas neste site são fornecidas "como estão", sem garantias de qualquer natureza. Não nos responsabilizamos por decisões tomadas com base no conteúdo do site, por eventuais interrupções no acesso, por falhas técnicas ou por danos decorrentes de vírus ou outros componentes maliciosos que possam afetar seu equipamento.</p>
            </section>

            <section>
              <h2 className="text-lg text-light-primary font-medium mb-3">6. Links externos</h2>
              <p>Este site pode conter links para sites de terceiros. Esses links são fornecidos apenas para conveniência e não implicam endosso ou responsabilidade sobre o conteúdo externo. Recomendamos que você verifique as políticas de privacidade e termos de uso de cada site externo que visitar.</p>
            </section>

            <section>
              <h2 className="text-lg text-light-primary font-medium mb-3">7. Privacidade e cookies</h2>
              <p>O uso deste site está sujeito à nossa <Link to="/politica-de-privacidade" className="text-gold hover:underline">Política de Privacidade</Link>, que descreve como coletamos, usamos e protegemos seus dados pessoais, em conformidade com a LGPD (Lei nº 13.709/2018).</p>
            </section>

            <section>
              <h2 className="text-lg text-light-primary font-medium mb-3">8. Comunicações via WhatsApp e formulários</h2>
              <p>Ao nos contatar por meio dos formulários ou do botão de WhatsApp disponíveis neste site, você consente com o recebimento de respostas e informações relacionadas à sua solicitação. Você pode solicitar o cancelamento desse contato a qualquer momento.</p>
            </section>

            <section>
              <h2 className="text-lg text-light-primary font-medium mb-3">9. Legislação aplicável</h2>
              <p>Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Quaisquer disputas oriundas da utilização deste site serão submetidas ao foro da Comarca de Curitiba/PR, com renúncia expressa a qualquer outro, por mais privilegiado que seja.</p>
            </section>

            <section>
              <h2 className="text-lg text-light-primary font-medium mb-3">10. Alterações</h2>
              <p>Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento, com efeito imediato após a publicação da versão atualizada nesta página. A data da última revisão está indicada no topo deste documento.</p>
            </section>

            <section>
              <h2 className="text-lg text-light-primary font-medium mb-3">11. Contato</h2>
              <p>Dúvidas sobre estes Termos? Entre em contato:</p>
              <ul className="list-none space-y-1 mt-2 pl-2">
                <li><strong className="text-light-secondary">E-mail:</strong> contato@luisbrunello.com.br</li>
                <li><strong className="text-light-secondary">Endereço:</strong> Curitiba, Paraná — Brasil</li>
              </ul>
            </section>

          </article>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermosUsoPage;
